import styled from "styled-components";

import UpdateButton from "@EditArticleContainer/shared/components/UpdateButton/UpdateButton";

export const ParagraphPartnerAxisMAWrapper = styled.div`
  position: relative;
`;

export const ParagraphPartnerAxisMAUpdateButton = styled(UpdateButton)`
  position: absolute;
  left: -1.6rem;
  top: 0;
  transform: translateX(-100%);
`;

export const TitleAxisRole = styled.b`
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-family: var(--font-pt-serif);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;
